import './js/btn-anchor';
import './js/createMainMarkup';
import './js/pagination';
import './js/preloader';
import './js/inputCheck';
import './js/localstorageApp';
import './js/modal-film-info';
import './js/changeTheme';
import './js/modal-team';
import './js/modal-authorization';
import './js/youTube';

import './js/auth-firebase';
